<template>

    <div class="accept-reject actions">
        
        <form @submit.prevent="submitVerdict()">
            <textarea v-model="reason" placeholder="Evt. begrundelse"></textarea>
            <input type="submit" value="Godkend" class="accept" @click="verdict = 'Godkend'">
            <input type="submit" value="Afvis" class="decline" @click="verdict = 'Afvis'">
        </form>
            
    </div>

</template>

<script>

    /*
     * Booking statuses:
     * 0: Pending approval
     * 1: Approved
     * 2: Rejected
     * 3: Cancelled
     */

    import axios from '../../utils/Http.js'
    import notify from '../../utils/notify/Notify.js'
    
    export default {

        props: [
            'booking' // Booking object
        ],
        data: function() {
            return {
                verdict: null,
                reason: ''
            }
        },
        methods: {
            submitVerdict: function() {
                let data = {
                        status_reason: this.reason
                    },
                    notification = ''

                if (this.verdict === 'Godkend') {
                    data.status = 1
                    notification = 'Du har godkendt reservationen'
                }
                if (this.verdict === 'Afvis') {
                    data.status = 2
                    notification = 'Du har afvist reservationen'
                }

                axios({
                    method: 'patch',
                    url: `/booking/booking/${ this.booking.id }/`,
                    data: data,
                    headers: {
                        'Authorization': 'Token ' + this.$store.state.auth.sessionKey
                    }
                })  
                .then(res => {
                    notify(notification, 'success')
                    this.$emit('booking-updated')
                })
                .catch(err => {
                    notify('Noget gik galt', 'error', err.response.data)
                })

            }
        }

    }

</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    .accept-reject {
        
        &.actions {
            justify-content: flex-start;
            padding: 1rem;

            button,
            a.btn,
            input[type="submit"] {
                margin: 0 .5rem 0 0;
            }
        }
        .accept {
            background-color: $success;
            color: darken($success, 50%);
            border-color: darken($success, 10%);
        }
        .decline {
            background-color: $danger;
            color: darken($danger, 50%);
            border-color: darken($danger, 10%);
        }
        textarea {
            margin: 0 0 .5rem;
        }

    }

</style>
